import { z } from 'zod';
import { PersistenceStorage } from '@store/persistence';
import { FilteredActivityFeedTypes, ActivityFeedState as store } from './store';

export const ActivityFeedMainFilterPersistence = PersistenceStorage({
  key: '@soundxyz/activityFeedFilter-v4',
  schema: z.nativeEnum(FilteredActivityFeedTypes),
  eager: true,
});

export const setActivityFeedFilter = (type: FilteredActivityFeedTypes) => {
  if (store.activityFeedFilter.activityFeedType === type) return;
  store.activityFeedFilter = { activityFeedType: type };

  ActivityFeedMainFilterPersistence.set(type);
};
